import { atom } from 'recoil';

const sellerFeventAppliedearchValueAtom = atom<string>({
  key: 'sellerFeventAppliedearchValueAtom',
  default: '',
});

export { sellerFeventAppliedearchValueAtom };
